import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=e84d4796&scoped=true&"
import script from "./BaseRadio.vue?vue&type=script&lang=js&"
export * from "./BaseRadio.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=e84d4796&scoped=true&lang=css&"
import style1 from "./BaseRadio.vue?vue&type=style&index=1&id=e84d4796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84d4796",
  null
  
)

export default component.exports